<template>
    <div class="container" id="adCarouselLoader">
        <div class="row">
            <div class="card col-xs-12 col-sm-6 col-md-4" v-for="i in displayCount" :key="i">
                <div class="card-body">
                    <div class="skeleton-image"></div>
                    <div class="skeleton-title"></div>
                    <div class="skeleton-buttons">
                        <div class="skeleton-button"></div>
                        <div class="skeleton-button"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            displayCount: 3,
        };
    },
    mounted() {
        this.updateDisplayCount();
        window.addEventListener('resize', this.updateDisplayCount);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateDisplayCount);
    },
    methods: {
        updateDisplayCount() {
            if (window.innerWidth <= 768) {
                this.displayCount = 1;
            } else {
                this.displayCount = 3;
            }
        },
    },
};
</script>

<style scoped>
#adCarouselLoader {
    margin: 10px;
    width: 100%;

    .row {
        display: flex;
        justify-content: center;
    }

    .card {
        flex: 1;
        max-width: 180px;
        margin: 10px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        padding: 20px;
        border: 1px solid #eee;

        @media (max-width: 820px) {
            max-width: 160px;
        }

        @media (max-width: 768px) {
            max-width: 100%;
            margin: 10px 0;
        }
    }

    .card-body {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: stretch;
        width: 100%;
        height: 300px;
    }

    .skeleton-image {
        height: 150px;
        width: 100%;
        background: linear-gradient(90deg, #eee 25%, #f2f2f2 50%, #eee 75%);
        background-size: 200% 100%;
        animation: loading 1.5s infinite linear;
        border-radius: 8px;

        @media (max-width: 768px) {
            height: 120px;
        }
    }

    .skeleton-title {
        height: 20px;
        width: 100%;
        background: linear-gradient(90deg, #eee 25%, #f2f2f2 50%, #eee 75%);
        background-size: 200% 100%;
        animation: loading 1.5s infinite linear;
        border-radius: 4px;

        @media (max-width: 768px) {
            height: 16px;
        }
    }

    .skeleton-buttons {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        width: 100%;

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 8px;
        }
    }

    .skeleton-button {
        height: 32px;
        width: 45%;
        background: linear-gradient(90deg, #eee 25%, #f2f2f2 50%, #eee 75%);
        background-size: 200% 100%;
        animation: loading 1.5s infinite linear;
        border-radius: 4px;

        @media (max-width: 768px) {
            width: 100%;
        }
    }

    @keyframes loading {
        100% {
            transform: translateX(100%);
        }
    }
}
</style>